// Only the four valid CSS hex-color notations: #RGB, #RGBA, #RRGGBB, #RRGGBBAA.
const HEX_COLOR_RE = /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

/** Neutral dark tile color used when a brand set has no color, or an invalid one. */
export const BRAND_SET_FALLBACK_BG = "#292D33";

/**
 * Single source of truth for validating a brand-set `color` before it is
 * used as a tile background — whether interpolated into an HTML string
 * (`getEntityIconHTML`) or passed to a React inline `style` object
 * (`EntityIcon`). Anything that isn't a strict hex notation (CSS injection
 * attempts, JS expressions, unquoted strings) falls back to the neutral
 * background, keeping both render paths behaviorally identical.
 */
export function resolveBrandSetBg(color: string | null | undefined): string {
  if (!color) return BRAND_SET_FALLBACK_BG;
  const trimmed = color.trim();
  return HEX_COLOR_RE.test(trimmed) ? trimmed : BRAND_SET_FALLBACK_BG;
}
